import { Container, Graphics, Point, Sprite, Texture } from "pixi.js";

export class ProgressBar extends Container {
    public readonly background: Sprite;
    public readonly progress: Sprite;
    private readonly progressMask: Graphics;

    public set value(value: number) {
        this.progressValue = Math.max(Math.min(value, 1), 0);
        this.onProgress();
    }

    public get value(): number {
        return this.progressValue;
    }

    public constructor(
        background: Texture,
        progress: Texture,
        private progressValue: number = 0
    ) {
        super();
        this.background = new Sprite(background);
        this.progress = new Sprite(progress);
        this.progressMask = new Graphics()
            .beginFill("#FFFFFF", 1)
            .drawRect(0, 0, this.progress.width, this.progress.height)
            .endFill();

        this.progress.mask = this.progressMask;
        this.addChild(
            this.background,
            this.progressMask,
            this.progress
        );
        this.onProgress();
    }

    public updateProgressPosition(x: number, y: number): void {
        this.progress.position.set(x, y);
        this.progressMask.position.copyFrom(this.progress.position);
    }

    protected onProgress(): void {
        this.progressMask.scale.x = this.progressValue;
    }
}